import { mapGetters } from 'vuex';

import { capitalizeFirstLetter, formatMontant } from '@/helpers/StringHelpers';

export default {
  methods: {
    mixinProduitCasino_getTitre(isHtml = true) {
      const langue = capitalizeFirstLetter(this.$i18n.locale);
      // eslint-disable-next-line no-nested-ternary
      const titre = this.produit[`titre${langue}`]
        ? this.produit[`titre${langue}`]
        : this.produit.titre
        ? this.produit.titre
        : '';
      let titreJeu =
        (this.produit[`prefixe${langue}`] ? `${this.produit[`prefixe${langue}`]} ` : '') + titre;
      if (this.produit[`exposant${langue}`]) {
        if (isHtml) {
          titreJeu += `<sup>${this.produit[`exposant${langue}`]}</sup>`;
        } else {
          titreJeu += ` ${this.produit[`exposant${langue}`]}`;
        }
      }
      return titreJeu;
    },
    mixinProduitCasino_getCategorie() {
      if (
        this.$i18n.t(`casino.categorie.${this.produit.categorie}`) !==
        `casino.categorie.${this.produit.categorie}`
      ) {
        return this.$i18n.t(`casino.categorie.${this.produit.categorie}.libelle`);
      }
      return '';
    },
    mixinProduitCasino_getLienPageProduit(urlParams = null) {
      return this.getLienInterneFromProduit(this.produit, urlParams);
    },
    mixinProduitCasino_getMiseMinMax(isHtml = true) {
      if (!this.produit.miseMin && !this.produit.betLimits?.CAD?.min) {
        return '';
      }
      const miseMin = formatMontant(this.produit.miseMin || this.produit.betLimits?.CAD?.min);

      // Si aucune mise max
      if (
        !this.produit.miseMax &&
        (!this.produit.betLimits?.CAD?.max ||
          this.produit.betLimits?.CAD?.min == this.produit.betLimits?.CAD?.max)
      ) {
        return miseMin;
      }

      return (
        miseMin +
        (isHtml ? '&nbsp;' : ' ') +
        this.$i18n.t('a') +
        (isHtml ? '&nbsp;' : ' ') +
        formatMontant(this.produit.miseMax || this.produit.betLimits?.CAD?.max)
      );
    },
    mixinProduitCasino_getMessage() {
      const desactivation =
        this.produitDesactivation ?? this.getStatutProduit(this.produit, this.$isMobile());
      if (desactivation) {
        const message = {};
        if (desactivation.message) {
          message.desactivation = desactivation.message;
        }
        if (desactivation.messageFenetre) {
          message.fenetre = desactivation.messageFenetre;
        }
        return message;
      }
      return false;
    },
  },
  computed: {
    ...mapGetters({
      getLienInterneFromProduit: 'produitCasino/getLienInterneFromProduit',
      getStatutProduit: 'produitCasino/getStatutProduit',
    }),
  },
};
